export default "__VITE_ASSET__B8qfLz7j__"